// Single source of truth for the in-article navigation of the
// "Voice Typing vs Built-In Dictation" comparison.
//
// The sidebar renders these in order and the scroll-spy watches the same ids,
// so adding a section here is all that is needed to wire it into both. The
// order follows the article's reading order so the scroll-spy always lands on
// the section the reader is actually looking at.
export const ARTICLE_SECTIONS = [
  {
    id: "what-counts-as-built-in-dictation",
    label: 'What counts as "built-in dictation"?',
  },
  {
    id: "what-makes-ai-voice-typing-different",
    label: "What makes AI voice typing different",
  },
  {
    id: "windows-dictation-vs-ai-voice-typing",
    label: "Windows dictation vs AI voice typing",
  },
  {
    id: "mac-dictation-vs-ai-voice-typing",
    label: "Mac dictation vs AI voice typing",
  },
  {
    id: "google-docs-voice-typing-comparison",
    label: "Google Docs voice typing comparison",
  },
  {
    id: "accuracy-speed-editing-gap",
    label: "Accuracy, speed, and the editing gap",
  },
  {
    id: "which-one-fits-your-workflow",
    label: "Which one fits your workflow",
  },
  {
    id: "faqs",
    label: "FAQ",
  },
];

// Offset used by both the scroll-spy and the smooth-scroll target so a section
// never lands underneath the fixed navbar.
export const SCROLL_OFFSET = 120;

// ---------------------------------------------------------------------------
// Type + surface tokens. These mirror the Voice Prompting AI and Google Docs
// articles exactly so every guide renders headings, body copy and cards with
// identical styling.
// ---------------------------------------------------------------------------

// Section heading, sized so every H2 on this page sits on a single line from
// sm up. The widest heading ("Google Docs Voice Typing Comparison") measures
// 18.6em in Plus Jakarta Sans Bold, so each breakpoint scales the size with
// the space the article column actually has (viewport minus page gutters,
// minus the sidebar from lg) and caps at 42px, which fits the 815.58px column.
// Below sm the column is too narrow for that and the heading wraps freely.
export const H2 =
  "font-jakarta font-bold text-[#0A0D16] text-[28px] sm:text-[clamp(26px,calc(5.2vw_-_3px),42px)] md:text-[clamp(26px,calc(5.2vw_-_6px),42px)] lg:text-[clamp(26px,calc(5.2vw_-_27px),42px)] leading-[1.28] sm:leading-[1.2] tracking-[-0.8px]";

// Standard body paragraph.
export const BODY =
  "font-inter text-[16px] font-normal leading-[29.6px] tracking-[0px] text-[#0A0D16B2]";

// Smaller body copy used inside cards, callouts and the comparison table.
export const BODY_SM =
  "font-jakarta text-[14px] font-normal leading-[24px] tracking-[0px] text-[#0A0D16B2]";

// Card / sub-section title.
export const CARD_TITLE =
  "font-jakarta text-[16.1px] font-bold leading-[26.16px] tracking-[0px] text-[#0A0D16]";

export const GRADIENT_TEXT =
  "inline-block bg-gradient-to-r from-[#3AB1F6] to-[#407BFF] bg-clip-text text-transparent";

export const CARD_SHADOW =
  "0px 10.73px 32.19px -12.88px #173A8C24, 0px 1.07px 2.15px 0px #0A0E190A";

// Inline link inside body copy.
export const INLINE_LINK =
  "text-[#3AB1F6] underline-offset-2 hover:underline";

// Light-blue surface shared by the callouts, the "when to use" cards and the
// two CTA panels.
export const SOFT_PANEL =
  "rounded-[17.17px] border-[1.34px] border-[#3AB1F633] bg-[#EBF7FE]";

// Article column width, matching the other guides.
export const ARTICLE_COLUMN = "w-full lg:max-w-[815.58px]";

// Vertical rhythm between a heading and the paragraph under it.
export const STACK_GAP = "mt-[25.76px]";
